import { PosthogClient } from "@App/utils/analytics/adapters/posthog";
import { AnalyticsMux } from "@App/utils/analytics/mux";
import { SentryClient } from "@App/utils/analytics/adapters/sentry";

export const analytics = new AnalyticsMux([PosthogClient, SentryClient]);
